import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/landing/Home.vue'
import Impressum from '../components/landing/Impressum.vue'
import Datenschutz from '../components/landing/Datenschutz.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/Impressum',
    name: 'Impressum',
    component: Impressum
  },
  {
    path: '/Datenschutz',
    name: 'Datenschutz',
    component: Datenschutz
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if(to==from&&from==savedPosition)
      return { x: 0, y: 0 }
    else
      return { x: 0, y: 0 }
  }
})

export default router
